import {
  createPlugin,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
  createComponentExtension,
} from '@backstage/core-plugin-api';
import { datadogApiRef, DatadogApiClient } from './api';
import { datadogRouteRef } from './routes';

export const datadogPlugin = createPlugin({
  id: 'datadog',
  featureFlags: [{ name: 'datadog' }],
  apis: [
    createApiFactory({
      api: datadogApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new DatadogApiClient(discoveryApi, fetchApi),
    }),
  ],
  routes: {
    root: datadogRouteRef,
  },
});

export const DatadogHealthCard = datadogPlugin.provide(
  createComponentExtension({
    name: 'DatadogHealthCard',
    component: {
      lazy: () =>
        import('./components/DatadogHealthCard/DatadogHealthCard').then(
          m => m.DatadogHealthCard,
        ),
    },
  }),
);

export const DatadogSloCard = datadogPlugin.provide(
  createComponentExtension({
    name: 'DatadogSloCard',
    component: {
      lazy: () =>
        import('./components/DatadogSloCard/DatadogSloCard').then(
          m => m.DatadogSloCard,
        ),
    },
  }),
);

export const DatadogIncidentBanner = datadogPlugin.provide(
  createComponentExtension({
    name: 'DatadogIncidentBanner',
    component: {
      lazy: () =>
        import(
          './components/DatadogIncidentBanner/DatadogIncidentBanner'
        ).then(m => m.DatadogIncidentBanner),
    },
  }),
);

export const DatadogDashboardCard = datadogPlugin.provide(
  createComponentExtension({
    name: 'DatadogDashboardCard',
    component: {
      lazy: () =>
        import('./components/DatadogDashboardCard/DatadogDashboardCard').then(
          m => m.DatadogDashboardCard,
        ),
    },
  }),
);

export const DatadogSummaryCard = datadogPlugin.provide(
  createComponentExtension({
    name: 'DatadogSummaryCard',
    component: {
      lazy: () =>
        import('./components/DatadogSummaryCard/DatadogSummaryCard').then(
          m => m.DatadogSummaryCard,
        ),
    },
  }),
);

export const DatadogEntityTab = datadogPlugin.provide(
  createComponentExtension({
    name: 'DatadogEntityTab',
    component: {
      lazy: () =>
        import('./components/DatadogEntityTab/DatadogEntityTab').then(
          m => m.DatadogEntityTab,
        ),
    },
  }),
);
